import { MerchTypeRenderer } from "./merch-type-renderer";
import { ColumnDef } from "@arelia-components/ui-atoms/data-grid";

export const API_ROUTE = "/api/earnings/merchandise";

export const merchandiseRevenueColumnConfig: ColumnDef[] = [{
  field: "merchSource",
  headerName: "Type",
  width: "15%",
  renderer: p =><MerchTypeRenderer merchSource={p.value}/>,
  editable: false
}, {
  field: "name",
  headerName: "Item",
  width: "25%",
  editable: true,
}, {
  field: "date",
  headerName: "Date",
  width: "15%",
  editable: true,
  type: "date"
}, {
  field: "location",
  headerName: "Location",
  editable: true,
  width: "30%"
}, {
  field: "amount",
  headerName: "Total",
  width: "15%",
  editable: true,
  type: "currency"
}];